module.exports = __webpack_public_path__ + "img/us_flag.96effbfd.png";